var map = {
	"./appointments.svg": "19e6",
	"./dashboard.svg": "0263",
	"./enquiries.svg": "42af",
	"./events.svg": "280f",
	"./graph.svg": "bfb7",
	"./marketing.svg": "6bc9",
	"./messages.svg": "29e6",
	"./news.svg": "deeb",
	"./payment.svg": "a682",
	"./settings.svg": "aca5",
	"./shop.svg": "0ef8",
	"./subscriptions.svg": "0060",
	"./users.svg": "06be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8ab";